// extracted by mini-css-extract-plugin
module.exports = {"phoneNumberWidget":"-sMOxT"};